import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  Metrics,
  QuickActions,
  TodaySchedule,
  ActivityTabs,
  JobStatusOverview,
  ServiceStatusOverview,
} from "./components";

export function DashboardComponent() {
  const [sharedDate, setSharedDate] = useState<Dayjs>(dayjs());

  return (
    <div className="space-y-4">
      <QuickActions />
      <ActivityTabs />
      <JobStatusOverview />
      {/* <ServiceStatusOverview /> */}
      <TodaySchedule onDateChange={setSharedDate} />
      <Metrics scheduleDate={sharedDate} />
    </div>
  );
}
